// watertest.js.liquid — Merged full logic

// Helper function to safely get and parse session values
function getSessionValue(key, isNumber = false) {
  const value = sessionStorage.getItem(key);
  if(value === null) return null;
  return isNumber ? parseFloat(value) : value;
}
// Handle bracket notation keys in sessionStorage
function getSessionValueWithBrackets(baseKey, property) {
  // Try both formats - with brackets and without
  const bracketKey = `${baseKey}[${property}]`;
  const simpleKey = property;
  
  // First try bracket notation
  let value = sessionStorage.getItem(bracketKey);
  
  // If not found, try simple key
  if (value === null) {
    value = sessionStorage.getItem(simpleKey);
  }
  
  return value !== null ? value : undefined;
}

// render html for the test results row
function renderTestResult(testName, result) {

  let productHtml = '';
  if (result.Products) {
      const sku = result.Products;
      const p = window.chemicalProducts[sku];

      if (p) {
          productHtml = `
              <div class="result-product-box">
                  <p>
                    <a href="${p.url}" class="result-product-link">${p.title}</a>
                  </p>
              </div>
          `;
          //<img src="${p.image}" alt="${p.title}" class="result-product-img" />
      } else {
          productHtml = '';
      }
  }

  return `
    <div class="result-row ${result.Class}">
      <div class="result-cell" style="flex:0.8">${testName}</div>
      <div class="result-cell" style="flex:1.6">
        <div class="result-box">
          <b>
            ${result.Info}
          </b>
          ${result.ExtraInfo ? `<div class="result-extra">${result.ExtraInfo}</div>` : ''}
        </div>
      </div>
      <div class="result-cell" style="flex:1">
        <div class="result-add-box">${result.Dosage}</div>
        ${productHtml}
      </div>        
    </div>
  `;
}

// display html to page from the render function
function displayResults(results) {
  // Digital tests
  if (results.Digital && Object.keys(results.Digital).length > 0) {
    let html = '';
    for (const [test, result] of Object.entries(results.Digital)) {
      if(result){
        html += renderTestResult(test, result);
      }
    }
    const resultsDigitalContainer = document.getElementById('digitalResults');
    resultsDigitalContainer.innerHTML = html;
  }
  // Strip tests
  if (results.Strip && Object.keys(results.Strip).length > 0) {
    let html = '';
    for (const [test, result] of Object.entries(results.Strip)) {
      if(result){
        html += renderTestResult(test, result);
      }
    }
    const resultsStripContainer = document.getElementById('stripResults');
    resultsStripContainer.innerHTML = html;
  }
}

// Save all the fields in the start test page
function handleStartSubmit(event) {
  event.preventDefault();
  const form = document.querySelector('.form-all');
  const inputs = form.querySelectorAll('input, select');
  inputs.forEach(input => {
    if (input.name && input.value !== '') {
      sessionStorage.setItem(input.name, input.value);
      console.log(input.name+' saved.');
    }
  });
  window.location.href = '/pages/watertest-results';
  return 
}

// Save selected test strip values to sessionStorage
function saveStripSelections() {
  document.querySelectorAll('.form-all input[type="hidden"]').forEach(input => {
    sessionStorage.setItem(input.name, input.value);
  });
}

// Load and apply saved test strip values from sessionStorage
function loadStripSelections() {
  document.querySelectorAll('.form-all input[type="hidden"]').forEach(input => {
    const saved = sessionStorage.getItem(input.name);
    if (saved) {
      input.value = saved;
      const picker = document.querySelector(`.colorPicker[data-input="${input.id}"]`);
      if (picker) {
        picker.querySelectorAll('.colorSquare').forEach(square => {
          square.classList.remove('active');
          if (square.dataset.value === saved) {
            square.classList.add('active');
          }
        });
      }
    }
  });
}

// Save digital form input values
function saveDigitalInputs() {
  document.querySelectorAll('.form-all input[type="number"]').forEach(input => {
    sessionStorage.setItem(input.name, input.value);
  });
}

// Load and apply digital form input values
function loadDigitalInputs() {
  document.querySelectorAll('.form-all input[type="number"]').forEach(input => {
    const saved = sessionStorage.getItem(input.name);
    if (saved) {
      input.value = saved;
    }
  });
}

// Clear sessionStorage for all test input fields (pool details in localStorage are kept)
function resetWatertestSession() {
  const keysToClear = [
    'Temperature', 'ORP', 'pH', 'EC', 'TDS', 'Salt', 'SaltPercent', 'SG',
    'poolStripTest[TotalHardness]', 'poolStripTest[FreeChlorine]',
    'poolStripTest[TotalChlorine]', 'poolStripTest[Alkalinity]', 'poolStripTest[pH]'
  ];
  keysToClear.forEach(key => sessionStorage.removeItem(key));
}

// Reset only the digital tester inputs
function resetDigitalTab() {
  ['Temperature', 'ORP', 'pH', 'EC', 'TDS', 'Salt', 'SaltPercent', 'SG'].forEach(key => {
    sessionStorage.removeItem(key);
    const field = document.querySelector(`.form-digital input[name="${key}"]`);
    if (field) field.value = '';
  });
}

// Reset only the strip test selections
function resetStripTab() {
  const stripKeys = [
    'poolStripTest[TotalHardness]',
    'poolStripTest[FreeChlorine]',
    'poolStripTest[TotalChlorine]',
    'poolStripTest[Alkalinity]',
    'poolStripTest[pH]'
  ];
  stripKeys.forEach(key => {
    sessionStorage.removeItem(key);
    const input = document.querySelector(`.form-strip input[name="${key}"]`);
    if (input) input.value = '';
  });

  // Remove active class from all strip color squares
  document.querySelectorAll('.form-strip .colorSquare.active').forEach(el => {
    el.classList.remove('active');
  });
}

document.addEventListener('DOMContentLoaded', function () {
  // Back button
  const backBtn = document.querySelector('.btn-back');
  if (backBtn && window.location.pathname !== '/pages/watertest-landing') {
    backBtn.style.display = 'block';
    backBtn.addEventListener('click', function () {
      window.history.back();
    });
  }

  // Tab switching
  const digitalTab = document.querySelector('.tab-digital');
  const stripTab = document.querySelector('.tab-strip');
  const digitalForm = document.querySelector('.digitalTester');
  const stripForm = document.querySelector('.testStrips');

  if (digitalTab && stripTab && digitalForm && stripForm) {
    digitalTab.addEventListener('click', function (e) {
      e.preventDefault();
      digitalTab.classList.add('active');
      stripTab.classList.remove('active');
      digitalForm.style.display = 'block';
      stripForm.style.display = 'none';
    });

    stripTab.addEventListener('click', function (e) {
      e.preventDefault();
      digitalTab.classList.remove('active');
      stripTab.classList.add('active');
      digitalForm.style.display = 'none';
      stripForm.style.display = 'block';
    });
  }

  // Load pool details from localStorage (persists across sessions)
  const poolForm = document.querySelector('.watertest-form');
  if (poolForm) {
    const storedPoolVolume = localStorage.getItem('poolVolume');
    const storedPoolType = localStorage.getItem('poolType');
    const storedPoolSurface = localStorage.getItem('poolSurface');
    const storedChlorineType = localStorage.getItem('chlorineType');

    if (storedPoolVolume) document.getElementById('poolVolume').value = storedPoolVolume;
    if (storedPoolType) document.getElementById('poolType').value = storedPoolType;
    if (storedPoolSurface) document.getElementById('poolSurface').value = storedPoolSurface;
    if (storedChlorineType) document.getElementById('chlorineType').value = storedChlorineType;

    poolForm.addEventListener('submit', function (e) {
      localStorage.setItem('poolVolume', document.getElementById('poolVolume').value);
      localStorage.setItem('poolType', document.getElementById('poolType').value);
      localStorage.setItem('poolSurface', document.getElementById('poolSurface').value);
      localStorage.setItem('chlorineType', document.getElementById('chlorineType').value);
    });
  }

  // Load saved values
  loadStripSelections();
  loadDigitalInputs();

  // Save values on form submit
  if (stripForm) {
    stripForm.addEventListener('submit', () => {
      saveStripSelections();
    });
  }
  if (digitalForm) {
    digitalForm.addEventListener('submit', () => {
      saveDigitalInputs();
    });
  }

  // Color picker logic
  document.querySelectorAll('.colorPicker').forEach(picker => {
    const inputId = picker.getAttribute('data-input');
    const hiddenInput = document.getElementById(inputId);
    picker.querySelectorAll('.colorSquare').forEach(square => {
      square.addEventListener('click', function () {
        picker.querySelectorAll('.colorSquare').forEach(sq => sq.classList.remove('active'));
        this.classList.add('active');
        if (hiddenInput) hiddenInput.value = this.dataset.value;
      });
    });
  });

  // Reapply colorSquare .active from hidden input
  document.querySelectorAll('input[type="hidden"]').forEach(hiddenInput => {
    const val = hiddenInput.value;
    if (val) {
      const selector = `.colorPicker[data-input="${hiddenInput.id}"] .colorSquare[data-value="${val}"]`;
      const activeSquare = document.querySelector(selector);
      if (activeSquare) activeSquare.classList.add('active');
    }
  });

  // Modal behavior
  const modal = document.getElementById('instructionsModal');
  const trigger = document.querySelector('.help-icon');
  const closeBtn = document.querySelector('.close-modal');

  if (modal && trigger && closeBtn) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      modal.style.display = 'block';
    });

    closeBtn.addEventListener('click', function () {
      modal.style.display = 'none';
    });

    window.addEventListener('click', function (e) {
      if (e.target === modal) {
        modal.style.display = 'none';
      }
    });
  }
});


